module.exports = __webpack_public_path__ + "static/media/bell.11025989.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bell.png
// module id = 266
// module chunks = 0